import { Button, Container, makeStyles, TextField, Typography, withStyles } from "@material-ui/core";
import { blue } from "@material-ui/core/colors";
import { Autocomplete } from "@material-ui/lab";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { getID, getStudentSelectList, submitSelectStudent } from "../action/studentSelectAction";
import { getTeacherIDbyLink } from "../firebase/firebaseController";
import Loading from "./Loading";


const ColorButton = withStyles((theme) => ({
    root: {
        color: theme.palette.getContrastText(blue[900]),
        backgroundColor: blue[900],
        '&:hover': {
            backgroundColor: blue[700],
        },
    },
}))(Button);

const useStyles = makeStyles({
    container: {
        minHeight: "100vh",
        height: "fit-content",
        minWidth: "515px",
        width: "100vw",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "20px",
        padding: "60px",
    },
    error: {
        color: "red",
    },
    avatar: {
        width: "50px",
        height: "50px",
        cursor: "pointer",
        backgroundColor: "red",
        position: "absolute",
        top: "10px",
        right: "10px",
        borderRadius: "50%",
        "&:hover": {
            opacity: "0.7",
        }
    },
    textArea: {
        minWidth: "400px",
        backgroundColor: "#d8d2d29f"
    },
    wrapper: {
        display: "flex",
        gap: "20px"
    }
});

export default function Student() {
    let history = useHistory();
    let { roomID } = useParams();
    let studentSelectState = useSelector(state => state.studentSelectState);
    console.log(roomID);
    let dispatch = useDispatch();
    let initialData = async ()=>{
         dispatch(getID(roomID));
         let teacherID = await getTeacherIDbyLink(roomID);
         dispatch(getStudentSelectList(teacherID));
    }
    useEffect(() => {
           initialData();
    // eslint-disable-next-line
    }, [])
    console.log(studentSelectState);
    let [value, setValue] = useState("");
    let classes = useStyles();
    let gotoNext =()=>{
        history.push("/answers");
    }
    let submiting = ()=>{
        dispatch(submitSelectStudent(value,gotoNext));
    }

    return (<>
        {!studentSelectState.loading&&
            <Container className={classes.container}>
            <Typography variant="h4" component="h1">
                Select Your Name
            </Typography>
            <Autocomplete
                blurOnSelect
                value={value}
                onChange={(event, newValue) => {
                    console.log("What are you?",newValue);
                    setValue(newValue);
                }}
                options={studentSelectState.listStudent}
                getOptionLabel={(option)=>option.name}
                renderInput={(params) => <TextField className={classes.textArea} {...params} variant="standard" />}
            />
            <ColorButton variant="contained" onClick={submiting}>Continue</ColorButton>
        </Container>
        }
        {studentSelectState.loading&&
            <Loading />
        }
    </>)
}